import { useCallback } from 'react';

import { IStore } from '@rbi-ctg/store';
import {
  GetRestaurantFzDetailsDocument,
  IGetRestaurantFzDetailsQuery,
} from 'generated/sanity-graphql';
import { useApolloClient } from 'state/graphql/hooks/use-sanity-query';
import { useSanityGqlEndpoint } from 'utils/network';

export const useRestaurantFzDetails = () => {
  const client = useApolloClient();
  const uri = useSanityGqlEndpoint();

  const getFzDetailsForRestaurant = useCallback(
    async (store: IStore): Promise<any> => {
      try {
        const response = await client.query<IGetRestaurantFzDetailsQuery>({
          query: GetRestaurantFzDetailsDocument,
          context: { uri },
          variables: {
            storeId: store._id,
          },
        });

        return response?.data?.Restaurant;
      } catch (e) {
        return false;
      }
    },
    [client, uri]
  );

  return { getFzDetailsForRestaurant };
};
